import type { ChangeEvent } from "react";
import type {
  TypedWrappedFieldProps,
  WrappedFieldInputProps,
} from "redux-form";

import type { TextFieldProps as TextFieldPropsBUC } from "@braintrust/braintrust-ui-components";
import { TextField as TextFieldCustom } from "@braintrust/braintrust-ui-components";

import type { TextFieldErrorProps } from "./helper-text";
import { TextFieldHelperText } from "./helper-text";

export type TextFieldProps = TextFieldPropsBUC &
  TextFieldErrorProps &
  TypedWrappedFieldProps<string>;

export const TextField = ({
  input,
  meta,
  helperText,
  mapErrorCode,
  hideError,
  showErrorWhen = "touched",
  ...props
}: TextFieldProps) => {
  const { error, submitFailed } = meta;
  const isError =
    !!error && (meta[showErrorWhen] || submitFailed) && !hideError;
  const showsHelperText = isError || !!helperText;

  return (
    <TextFieldCustom
      {...props}
      {...input}
      onChange={(e: ChangeEvent<HTMLInputElement>) => {
        if (props.onChange) {
          props?.onChange(e);
        }
        (input as WrappedFieldInputProps).onChange(e);
      }}
      onDrop={
        props.disabled
          ? () => {
              return null;
            }
          : input.onDrop
      }
      helperText={
        showsHelperText ? (
          <TextFieldHelperText
            meta={meta}
            mapErrorCode={mapErrorCode}
            hideError={hideError}
            showErrorWhen={showErrorWhen}
            helperText={helperText}
          />
        ) : undefined
      }
      error={(submitFailed || meta[showErrorWhen]) && !!error}
    />
  );
};
